import React from 'react';
import { CommonBackContent } from '../Layouts/CommonBackContent';
import dynamic from 'next/dynamic';
import WhatCanWeDoForYou from './WhatCanWeDoForYou';
import WithErasa from './WithErasa';

const TopView = dynamic(() => import('./TopView'), {
  ssr: true,
});
const FeaturesSectionContent = dynamic(() => import('./FeaturesSection'), {
  ssr: true,
});
const WhatCreatorsSayContent = dynamic(() => import('./WhatCreatorsSayContent'), {
  ssr: true,
});
const FAQSection = dynamic(() => import('./FAQSection'), {
  ssr: true,
});
const ComparisonSection = dynamic(() => import('./comparison-section'), {
  ssr: true,
});

const OnlyfansProtectionContent = ({ data }: { data: any }) => {
  return (
    <div>
      <CommonBackContent>
        <TopView />
        <ComparisonSection />
        <WithErasa />
        <WhatCanWeDoForYou />
        <FeaturesSectionContent />
      </CommonBackContent>

      {data.contentInfo['section-testimonial'].title && <WhatCreatorsSayContent data={data} />}

      <CommonBackContent>
        <FAQSection data={data} />
      </CommonBackContent>
    </div>
  );
};

export default OnlyfansProtectionContent;
